(function () {
  const menu = document.getElementById('MobileMenu');
  const toggle = document.querySelector('.menu-toggle');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.addEventListener('click', function (event) {
    const qty = event.target.closest('[data-qty]');
    if (qty) {
      const input = qty.closest('.quantity-box')?.querySelector('input');
      if (!input) return;
      const next = Math.max(1, (parseInt(input.value || '1', 10) || 1) + parseInt(qty.dataset.qty, 10));
      input.value = next;
    }
  });

  const json = document.getElementById('ProductVariants');
  const form = document.getElementById('ProductForm');
  if (!json || !form) return;
  const variants = JSON.parse(json.textContent || '[]');
  const idInput = document.getElementById('VariantId');
  const price = document.getElementById('ProductPrice');
  const add = document.getElementById('AddToCart');
  const groups = Array.from(document.querySelectorAll('.variant-group'));
  const productOptions = variants.length ? variants[0].options : [];
  const optionOffset = productOptions.length === groups.length ? 0 : Math.max(0, productOptions.length - groups.length);

  const money = function (cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents);
    return '$' + (Number(cents) / 100).toFixed(2);
  };

  function selectedValues() {
    return groups.map(function (group) {
      return group.querySelector('.variant-button[aria-pressed="true"]')?.dataset.value || null;
    });
  }

  function refresh() {
    const selected = selectedValues();
    groups.forEach(function (group, groupIndex) {
      const variantIndex = groupIndex + optionOffset;
      group.querySelectorAll('.variant-button').forEach(function (button) {
        const test = selected.slice();
        test[groupIndex] = button.dataset.value;
        const possible = variants.some(function (variant) {
          return variant.options.every(function (value, optionIndex) {
            if (optionIndex === 0 && optionOffset === 1 && productOptions[0] === 'Default Title') return true;
            const selectedValue = test[optionIndex - optionOffset];
            return !selectedValue || value === selectedValue;
          });
        });
        button.disabled = !possible;
      });
    });
    const exact = variants.find(function (variant) {
      return groups.every(function (group, groupIndex) {
        return variant.options[groupIndex + optionOffset] === selected[groupIndex];
      });
    });
    if (!exact) return;
    idInput.value = exact.id;
    price.textContent = money(exact.price);
    add.disabled = !exact.available;
    add.textContent = exact.available ? 'Add to cart' : 'Sold out';
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.variant-button');
    if (!button) return;
    const group = button.closest('.variant-group');
    group.querySelectorAll('.variant-button').forEach(function (item) { item.setAttribute('aria-pressed', 'false'); });
    button.setAttribute('aria-pressed', 'true');
    refresh();
  });

  form.addEventListener('submit', function () {
    if (!add.disabled) {
      add.disabled = true;
      add.textContent = 'Adding…';
    }
  });

  refresh();
})();
